export default __webpack_public_path__ + "static/media/basket-white.bb8b716c.svg";